<template>
  <div>
    <el-dialog class="uppwd" v-dialogDrag title="修改密码" :visible.sync="isUpdatePwdDialog" @close="clearFun" width="500px" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form size="medium" :model="uppwd" ref="uppwd" :rules="rules" label-width="100px">
        <el-form-item label="账号：" prop="username">
          <el-input v-model="uppwd.username" :disabled="true"/>
        </el-form-item>
        <el-form-item label="原密码：" prop="password">
          <el-input type="password" v-model="uppwd.password"/>
        </el-form-item>
        <el-form-item label="新密码：" prop="onePassword">
          <el-input type="password" v-model="uppwd.onePassword"/>
        </el-form-item>
        <el-form-item label="确认密码：" prop="twoPassword">
          <el-input type="password" v-model="uppwd.twoPassword"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="isUpdatePwdDialog = false" size="small">取消</el-button>
        <el-button type="primary" size="small" @click="saveFun">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'UpdatePwd',
  data() {
    //两次密码是否一致检查
    let checkPwdSame = (rule, value, callback) => {
      if(value != this.uppwd.onePassword){
        callback(new Error('两次密码不一致'))
      }
      else {
        callback()
      }
    }
    return {
      //窗口开关控制
      isUpdatePwdDialog: false,
      //用户ID
      userId: null,
      //数据
      uppwd: {
        username: '',
        password: '',
        onePassword: '',
        twoPassword: ''
      },
      //校验规则
      rules: {
        password: [{
          required: true,
          message: '请输入原密码',
          trigger: 'blur'
        }],
        onePassword: [{
          required: true,
          message: '请输入新密码',
          trigger: 'blur'
        }],
        twoPassword: [{
          required: true,
          message: '请再次确认密码',
          trigger: 'blur'
        }, {
          validator: checkPwdSame,
          trigger: 'blur'
        }]
      }
    }
  },
  methods: {
    //清除表单数据
    clearFun: function(){
      this.$refs.uppwd.resetFields()
    },
    //提交
    saveFun: function(){
      this.$refs.uppwd.validate((valid) => {
        if (valid) {
          //数据提交保存
          this.$axios({
            method: 'post',
            url: '/sysUser/updatePwd',
            data: this.$qs.stringify({
              id: this.userId,
              oldPwd: this.uppwd.password,
              newPwd: this.uppwd.onePassword
            })
          }).then(response => {
            this.isUpdatePwdDialog = false
            this.$message.success('密码修改成功~')
          })
        } else {
          return false;
        }
      });
    }
  },
  mounted () {
    let user = JSON.parse(sessionStorage.getItem('user'));
    //用户名赋值
    this.uppwd.username = user.username
    //用户ID
    this.userId = user.id
  }
}
</script>

<style>
.uppwd .el-dialog__header {
  height: 28px;
  line-height: 28px;
}
.uppwd .el-dialog__footer {
  height: 55px;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/main/UpdatePwd.vue